export default __webpack_public_path__ + "static/media/Icon DICE.6c9b989f.png";